<template>
  <div>
    <div>
      <div class="tinymce-editor">
        <editor v-model="myValue" :init="{...init,placeholder}"  @input="editorChange"></editor>
      </div>
    </div>
  </div>
</template>

<script>
  import tinymce from "tinymce/tinymce";
  import Editor from "@tinymce/tinymce-vue";
  import "tinymce/themes/silver";
  import "tinymce/plugins/lists"; // 列表插件
  import "tinymce/plugins/link";
  // import WNavbar from '@/components/global/w-navbar'
  // import TinymceEditor from '../text-editor/index'
  // import WLoading from '@/components/global/w-loading'
  // import cvTips from '../../cv-components/cv-tips'
  // import GPA from '../../cv-components/GPA'
  // import suggestCard from '../../cv-components/suggest-card'
  // import { mapActions, mapState, mapMutations } from 'vuex'
  // import { moduleMixin } from '../../../assets/js/mixin/cv'
  import { envMixin } from '@/assets/js/mixin/global'
  import { componentsMixin } from "@/assets/js/mixin/components";
  // import { deleteRedundancy } from '@/assets/js/utils'
  // import { addClass } from '@/assets/js/dom'
  // import { eventMixin } from '../../../assets/js/mixin/global'
  // import { userMixin } from '../../../assets/js/mixin/user'

  export default {
    mixins: [componentsMixin,envMixin],
    props: {
      baseUrl: {
        type: String,
        default:
          process.env.VUE_APP_ENV === "local"
            ? ""
            : process.env.VUE_APP_OSS,
      },
      experienceShow: {
        type: Boolean,
        default: false,
      },
      experienceToolTip: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        text: "",
        type: "example",
        exampleIndex: 0,
        currentVerb: "",
        // verbs: [],
        verbList: [],
        option: "",
        tag: "",
        example: {},
        loadingShow: true,
        description: "",
        gpaState: false,
        init: {
          language_url: `${this.baseUrl}/tinymce/langs/zh_CN.js`,
          language: "zh_CN",
          skin_url: `${this.baseUrl}/tinymce/skins/ui/oxide`,
          content_css: `${this.baseUrl}/tinymce/skins/content/default/content.css`,
          height: 300,
          plugins: "lists link",
          toolbar:
            "undo redo bold italic bullist numlist outdent indent link removeformat",
          toolbar_sticky: true,
          branding: false,
          menubar: false,
          paste_remove_styles_if_webkit: true,
          paste_remove_styles: true,
          setup: (ed) => {
            ed.on("keyup", (e) => {
              console.log("事件对象∂", e);
              console.log("编辑器对象", ed);
              console.log("the content" + ed.getContent());
              this.$emit("input", ed.getContent());
              this.myValue = ed.getContent();
              let timer = setTimeout(() => {
                clearTimeout(timer);
                window.ReactNativeWebView.postMessage(
                  ed.getContent()
                );
              }, 500);
            });
          },
          placeholder:'11'
        },
        myValue: "",
        newModuleType: "",
        disabled: false,
        cvType:''
      };
    },
    async mounted() {
      const isUIWebView = () => {
        return navigator.userAgent.toLowerCase().match(/\(ip.*applewebkit(?!.*(version|crios))/)
      };
      const receiver = isUIWebView() ? window : document;
      receiver.addEventListener("message", (e) => {
        let msg = JSON.parse(e.data) || {};
        this.myValue = msg.data;
        this.newModuleType = msg.moduleType;
        // this.cvType = msg.cvType;
      });
      setTimeout(() => {
        this._calcHeight();
      }, 1000);
    },
    components: {
      Editor,
    },
    watch: {
      placeholder(newValue){
        this.showToast(newValue);
        tinymce.init({...this.init,placeholder:this.placeholder});
      },
      value (newValue) {
        this.myValue = newValue;
        window.ReactNativeWebView.postMessage(e);
      },
    },
    computed: {
        // 富文本编辑器的placeholder
        placeholder() {
            // // let { basic_i
            // switch (this.newModuleType) {
            //     // case 'personal_summary':
            //     //     if (this.cvType.includes('grad')) {
            //     //         return '简短分条地总结与申请专业相关的经验、技能以及能力'}
            //     // case 'project_experience':
            //     //     if (this.cvType.includes('programmer')) {
            //     //         return '简要说明参与开发的项目，附加超链接，展现自己的专业能力'
            //     //     } else {
            //     //         return '介绍在什么样项目中自己负责的内容，列出通过什么动作或技能达到了什么成果（最好是可量化的）'
            //     //     }
            //     case "reasearch_experience":
            //         return "介绍研究项目如毕业论文，小组项目等，描述负责的具体内容，以及最终的项目成果，受到导师好评、获奖情况等";break;
            //     case "skill_list":
            //         return "按照 “技能领域：编程语言（掌握程度）” 的格式罗列专业技能，如：Web开发：Python（熟练）";break;
            //     case "custom":
            //         return "介绍在什么经历中，通过某些活动或技能，达到了什么样的成果";break;
            //     case "edus":
            //         return "可以列出成绩、荣誉奖项、相关课程等";break;
            //     case "works":
            //         return "简短介绍公司与自己负责的任务，分条罗列在什么项目中，通过某些动作或技能达到可量化的结果";break;
            //     case "orgs":
            //         return "介绍在什么活动中自己负责的内容，列出通过什么动作获得了什么成果";break;
            // }
            return "请输入...";

      },
      // 中文工作模板
      workCn() {
        let lang = this.cv.basic_info.lang;
        return this.moduleType === "works" && lang === "cn";
      },
    },
    methods: {
      // 计算富文本编辑器的高度
      _calcHeight() {
        // this.init.placeholder = this.placeholder
        let editor = document.querySelector(".tinymce-editor");
      },
      editorChange(e){
        this.myValue = e;
        window.ReactNativeWebView.postMessage(e);
      }
    },
  };
</script>

<style scoped lang="scss">
  @import "@/assets/scss/global/variable";
  @import "@/assets/scss/global/mixin";
  .edit-content {
    width: 100vw;
    padding-top: 44px;
    height: 100vh;
    box-sizing: border-box;
    position: relative;
    .bottom {
      /*position: absolute;*/
      /*bottom: 0;*/
      .suggest-wrapper {
        .suggest-card {
          position: static;
          transform: translateX(0);
          left: 0;
        }
      }
      .row-reverse {
        flex-direction: row-reverse;
      }
      .content-course {
        padding: 16px 24px 38px;
        background-color: $color-light;
        .course-header {
          margin-bottom: 16px;
          .course-text {
            color: #9c9c9c;
            line-height: 20px;
            margin-right: 24px;
          }
          .text-active {
            color: $color-dark-gray;
            font-weight: 500;
          }
          .tips {
            position: relative;
            color: #4183ff;
            .w-tooltip {
              position: absolute;
              bottom: 40px;
              /deep/ .triangle {
                left: 160px;
              }
            }
            .iconfont {
              font-weight: 400;
              margin-right: 8px;
              font-size: 18px;
            }
          }
        }
        .only-tips {
          margin-bottom: 0;
        }
        .course-area {
          position: relative;
          background-color: #f9f9f9;
          padding: 16px 20px;
          .indicate {
            position: absolute;
            top: -12px;
            left: px2rem(20px);
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-bottom: 12px solid #f9f9f9;
          }
          .indicate-verb {
            left: px2rem(100px);
          }
          .no-content {
            display: none;
          }
          .course-container {
            .cube-select {
              flex: 1;
              display: flex;
              align-items: center;
              height: 38px;
              border: 1px solid #d9d9d9;
              color: $color-dark-gray;
              border-radius: 2px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              background-color: #f9f9f9;
              &:last-child {
                margin-left: 15px;
              }
              &::after {
                border: none;
              }
            }
            .cube-select_active::after {
              border: none;
            }
            .example-wrapper {
              .example-select {
                margin-bottom: 16px;
              }
              .example-container {
                height: 80px;
                margin-bottom: 10px;
                .example-content {
                  p {
                    color: $color-dark-gray;
                    line-height: 20px;
                  }
                }
              }
              .example-footer {
                .use-example {
                  color: #4183ff;
                  line-height: 20px;
                  .iconfont {
                    font-size: 14px;
                    margin-right: 8px;
                  }
                }
                .change-example {
                  .iconfont {
                    color: #4183ff;
                    margin-right: 4px;
                  }
                  .count {
                    margin-right: 8px;
                    color: #4183ff;
                    line-height: 20px;
                    letter-spacing: 1px;
                  }
                }
              }
            }
            .verb-wrapper {
              height: 126px;
              padding-top: 4px;
              .verb-list {
                flex-wrap: wrap;
                span {
                  width: 50%;
                  text-align: center;
                  line-height: 20px;
                  color: $color-dark-gray;
                  margin-top: 6px;
                }
              }
            }
          }
        }
        .no-area {
          padding: 0;
          background-color: $color-light;
        }
      }
    }
  }
  .tinymce-editor {
    /deep/ .tox-tinymce {
      border: none;
      box-sizing: border-box;
      .tool-bar {
        position: fixed;
        top: 44px;
      }
      .tool-bar-ios {
        position: fixed;
        top: 0;
      }
      .editor-container {
        padding-top: 40px;
      }
      .tox-statusbar {
        display: none;
      }
      .tox-toolbar__group {
        width: 100vw;
        display: flex;
        justify-content: space-between;
      }
    }
    /deep/ .mce-content-body {
      .check-highlight {
        color: $color-theme;
      }
    }
    height: calc(100vh - 20px);
  }
  .ios-content {
    height: calc(100vh - 88px);
    .ios-content-course {
      padding-bottom: 0 !important;
    }
  }
</style>
